<template>
  <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm select-none" aria-label="Page navigation ">
    <ul class="flex gap-x-2">
      <li v-if="currentPage !== 1" class="px-1.5 py-0.5 dark:text-white cursor-pointer">
        <div @click.prevent="goToPage(currentPage - 1)">
          {{ "" }}
        </div>
      </li>
      <li
        :class="[
          `px-1.5 py-0.5 dark:text-white cursor-pointer ${currentPage == 1 ? 'border dark:border-dark-divider-border rounded-md' : ''}`
        ]">
        <div @click.prevent="goToPage(1)">
          1
        </div>
      </li>
      <li v-if="currentPage - 2 > 1" :class="[`px-1.5 py-0.5 dark:text-white cursor-pointer`]">
        <div>...</div>
      </li>
      <li v-if="currentPage > 2" :class="[` px-1.5 py-0.5 dark:text-white cursor-pointer`]">
        <div @click.prevent="goToPage(currentPage - 1)">
          {{ currentPage - 1 }}
        </div>
      </li>
      <li
        v-if="currentPage !== 1 && currentPage !== totalPages"
        :class="[`dark:text-white border dark:border-dark-divider-border rounded-md px-1.5 py-0.5 cursor-pointer`]">
        <div>{{ currentPage }}</div>
      </li>
      <li v-if="currentPage + 1 < totalPages" :class="[`px-1.5 py-0.5 dark:text-white cursor-pointer`]">
        <div @click.prevent="goToPage(currentPage + 1)">
          {{ currentPage + 1 }}
        </div>
      </li>
      <li v-if="currentPage == 1 && currentPage + 2 < totalPages" :class="[`px-1.5 py-0.5 dark:text-white cursor-pointer`]">
        <div @click.prevent="goToPage(currentPage + 2)">
          {{ currentPage + 2 }}
        </div>
      </li>
      <li v-if="currentPage == 1 && currentPage + 3 < totalPages" :class="[`px-1.5 py-0.5 dark:text-white cursor-pointer`]">
        <div>...</div>
      </li>
      <li v-if="currentPage > 1 && currentPage + 2 < totalPages" :class="[`px-1.5 py-0.5 dark:text-white cursor-pointer`]">
        <div>...</div>
      </li>
      <li
        :class="[
          `px-1.5 py-0.5  dark:text-white cursor-pointer ${currentPage == totalPages ? 'border dark:border-dark-divider-border rounded-md' : ''}`
        ]">
        <div @click.prevent="goToPage(totalPages)">
          {{ totalPages }}
        </div>
      </li>
      <li v-if="currentPage !== totalPages" class="px-1.5 py-0.5 dark:text-white cursor-pointer">
        <div @click.prevent="goToPage(currentPage + 1)">
          {{ ">" }}
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  emits: ["update:currentPage", "input"],

  methods: {
    goToPage(page) {
      if (page < 1 || page > this.totalPages) {
        return
      }
      this.$emit("update:currentPage", page)
      this.$emit("input", page)
    }
  }
}
</script>
